import { render, staticRenderFns } from "./Writing2.vue?vue&type=template&id=501a9ec8&scoped=true"
import script from "./Writing2.vue?vue&type=script&lang=js"
export * from "./Writing2.vue?vue&type=script&lang=js"
import style0 from "./Writing2.vue?vue&type=style&index=0&id=501a9ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501a9ec8",
  null
  
)

export default component.exports